import React from 'react';
import { SectionHeading } from './ui/SectionHeading';
import { FadeIn } from './ui/FadeIn';
export function Comparacion() {
  const sinCheck = ['Vas al taller sin saber qué revisar.', 'Aceptás presupuestos sin entenderlos.', 'Dependés 100% del mecánico.', 'Pagás de más sin darte cuenta.'];
  const conCheck = ['Sabés qué mirar antes de ir.', 'Entendés las señales de alerta.', 'Tenés checklists y pasos claros.', 'Llegás con más seguridad.', 'Tenés más control antes de pagar.'];
  return <section className="bg-mc-dark2 py-[72px] px-5" data-id="element-42">
      <div className="max-w-[1100px] mx-auto" data-id="element-43">
        <FadeIn data-id="element-44">
          <SectionHeading centered data-id="element-45">
            Una mala visita al taller te puede{' '}
            <span className="text-mc-yellow" data-id="element-46">
              costar mucho más que este pack
            </span>
          </SectionHeading>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-7 mt-10 max-w-[900px] mx-auto" data-id="element-47">
          <FadeIn delay={0.1} data-id="element-48">
            <div className="bg-mc-gray border-2 border-mc-gray3 rounded-xl py-7 px-6 flex flex-col gap-3 h-full" data-id="element-49">
              <div className="font-display text-base font-black uppercase pb-3 border-b border-mc-gray3 text-mc-red" data-id="element-50">
                ❌ Sin Mecánico Check
              </div>
              {sinCheck.map((item, i) => <div key={i} className="flex gap-3 items-start text-[0.93rem] text-mc-text" data-id="element-51">
                  <span className="shrink-0 text-base mt-0.5 text-mc-red" data-id="element-52">
                    ✗
                  </span>
                  <span data-id="element-53">{item}</span>
                </div>)}
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-54">
            <div className="bg-gradient-to-br from-[#1a1a00] to-mc-gray border-2 border-mc-yellow rounded-xl py-7 px-6 flex flex-col gap-3 h-full" data-id="element-55">
              <div className="font-display text-base font-black uppercase pb-3 border-b border-mc-gray3 text-mc-yellow" data-id="element-56">
                ✅ Con Mecánico Check
              </div>
              {conCheck.map((item, i) => <div key={i} className="flex gap-3 items-start text-[0.93rem] text-mc-text" data-id="element-57">
                  <span className="shrink-0 text-base mt-0.5 text-mc-green" data-id="element-58">
                    ✓
                  </span>
                  <span data-id="element-59">{item}</span>
                </div>)}
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}